export const blockIconsAudioandvideoLibraryAdd = (
	<span className='material-symbols-outlined'>library_add</span>
);
